import { useEffect, useState } from 'react';
import { api } from './api';

/** ¿Este Conforme es el entorno de prueba? Se consulta una vez; sirve también para las pantallas sin sesión. */
export function useInstanceMode(): 'produccion' | 'prueba' | null {
  const [mode, setMode] = useState<'produccion' | 'prueba' | null>(null);
  useEffect(() => { api.get('/instance').then((r: { mode: 'produccion' | 'prueba' }) => setMode(r.mode)).catch(() => setMode('produccion')); }, []);
  return mode;
}
